/**
 * Component: Variant Grid Item.
 * -----------------------------------------------------------------------------
 * Logic related to variant grid item on sale collections.
 * @namespace variantGridItem
 */

/**
 * DOM selectors.
 */
const selectors = {
  hoverImage: '[js-variant-grid-item="hoverImage"]',
}

/**
 * Create a new variant grid item object.
 */
export default () => {

  /**
   * DOM node selectors.
   */
  const nodes = {
    hoverImage: document.querySelectorAll(selectors.hoverImage),
  }

  /**
   * Set hover images from productwiz app data.
   */
  function setHoverImages() {
    const { productWizData, productWizImages } = window

    nodes.hoverImage.forEach((image) => {
      const { productId, variantId } = image.dataset
      const productData = productWizData[productId]
      const { imageFilenames, mapping } = productData
      const found = mapping.find((obj) => obj.id === variantId)

      if (!found) {
        return
      }

      const imageFile = imageFilenames.find((file) => file.id === found.media[1])
      const imageValues = Object.values(productWizImages)
      const imageObj = imageValues.find((obj) => obj.src.includes(imageFile.value))

      if (!imageObj) {
        return
      }

      const { alt, src } = imageObj

      image.alt = alt
      image.src = src
    })
  }

  /**
   * Initialize component.
   */
  function init() {
    if (!nodes.hoverImage.length) {
      return
    }

    setHoverImages()
  }

  /**
   * Expose public interface.
   */
  return Object.freeze({
    init,
  })
}
